import { render, staticRenderFns } from "./products-table.vue?vue&type=template&id=8a16505e&"
import script from "./products-table.vue?vue&type=script&lang=js&"
export * from "./products-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports